import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { UtilitiesService } from '../../services/utilities.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GlobalVariables } from '../../constants/global-constants';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-profile-menu',
  standalone: true,
  imports: [MatButtonModule, MatMenuModule, MatIconModule, MatTooltipModule, CommonModule],
  templateUrl: './profile-menu.component.html',
  styleUrl: './profile-menu.component.scss',
})
export class ProfileMenuComponent {
  clientId = 0;
  profileMenuTooltip = GlobalVariables.Profile_Menu_Tooltip_Messaage;
  isSelectClientRoute: boolean;
  isOnboarding: boolean = false;

  constructor(
    private cookies: CookieService,
    public route: Router,
    public utilities: UtilitiesService) {
    this.clientId = this.utilities.clientId;
    this.utilities.companyStatus$.subscribe(res => {
      this.isOnboarding = res === 'Onboarding' ? true : false;
    })
  }


  logout() {
    this.utilities.clearUserContext();
    this.cookies.set('token', '', {
      expires: new Date(0),
      path: '/',
      secure: true,
      sameSite: 'Strict',
    });
    this.route.navigate(['login']);
  }

  backToOnboarding() {
    let onboardingId = localStorage.getItem('onboardingId');
    this.route.navigate(['client-onboarding', this.clientId, onboardingId]);

  }
}
